/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'ai-mate.chat-error-banner.description': 'Ihr Chatverlauf wird bis zu 30 Tage gespeichert.',
  'ai-mate.chat-error-banner.title': 'Neuen Chat beginnen',
  'ai-mate.chat-error.description': 'Versuchen Sie den <btn>Chat neu zu laden</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Sie haben die maximale Anzahl Anfragen erreicht. Bitte versuchen Sie es später erneut.',
  'ai-mate.chat-error.rate-limited-title': 'Zu viele Anfragen',
  'ai-mate.chat-error.rovo-inactive-description':
    'Rovo ist auf Ihrer Site scheinbar noch nicht aktiviert. <link>Rovo einrichten</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo ist inaktiv',
  'ai-mate.chat-error.title': 'Wir sind nicht sicher, was schiefgelaufen ist.',
  'ai-mate.main-chat.close-chat-button-label': 'Schließen',
  'ai-mate.main-chat.maximize-chat-button-label': 'Vollbild',
  'ai-mate.main-chat.minimize-chat-button-label': 'Ansicht wiederherstellen',
  'ai-mate.main-chat.new-chat-button-label': 'Neu',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Neuer Chat',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Rovo-Chat',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Senden',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Fragen Sie AI danach',
  'highlight-actions.rovo-chat-explain-option.text': 'Erklären',
  'highlight-actions.rovo-chat-explain-prompt':
    'Erklären Sie dies, indem Sie es umformulieren und zusätzliche Details hinzufügen. Verwenden Sie dabei sehr einfache Sprache und kurze Sätze und geben Sie für Fachbegriffe aus dem Originaltext Beispiele oder eine Definition an.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Ressourcen finden',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Suchen Sie nur innerhalb des Unternehmenswissens nach Ressourcen, die die Aussagen unterstützen.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Nennen Sie Beispiele',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Nennen Sie Beispiele auf der Grundlage von Unternehmensressourcen oder öffentlich zugänglichem Wissen. Wenn keine Ressourcen zur Verfügung stehen, geben Sie ein metaphorisches Beispiel, das zum besseren Verständnis beitragen könnte.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Feedback geben',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Geben Sie Feedback, indem Sie die Ausdrucksweise überprüfen. Stellen Sie Kommentare zur Wortwahl, Grammatik und Zeichensetzung bereit. Seien immer positiv und motivierend, aber nennen Sie immer mindestens eine Sache, die verbessert oder geändert werden könnte.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Chatempfehlungen',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Chat öffnen',
  'highlight-actions.rovo-chat-summarize-option.text': 'Zusammenfassen',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Heben Sie die wichtigsten Punkte hervor. Konzentrieren Sie sich auf die wesentlichen Informationen und lassen Sie unwichtige Details aus. Geben Sie in einem einzelnen Absatz einen Überblick über den Inhalt wieder.',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Im Chat fragen',
  'horizontal-scroll-container.scroll-left': 'Nach links scrollen',
  'horizontal-scroll-container.scroll-right': 'Nach rechts scrollen',
};
